import './saleForm.scss';

import { Formik } from 'formik';
import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';

import { useModal } from '@/resources/hooks/useModal';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { ApplicationState } from '@/store';
import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

import {
  FormContentRenderer,
  getInitialFormValues,
  useCartHandlers,
  useCartItemState,
} from './components';

interface Props {
  fullWidth?: boolean;
  formClasses?: string;
  styles?: CSSProperties;
  btnStyles?: CSSProperties;
  currentMeasure: 'kg' | 'unity';
  product: IProduct | ICartProduct | null;
  pbmBuyButton?: boolean;
  quantityInputDirection?: 'center' | 'end';
  isAvailable?: boolean;
  showType?: 'Default' | 'Product' | 'Carousel' | 'OneLine';
  hideQuantityInput?: boolean;
}

function SaleForm({
  product,
  currentMeasure,
  styles = {},
  btnStyles = {},
  formClasses = '',
  pbmBuyButton = false,
  fullWidth = false,
  quantityInputDirection,
  isAvailable,
  showType,
  hideQuantityInput = false,
}: Props) {
  const { order, configs, setShowCartAlertModal, setShowIdenfificationModal } = useWebContext();
  const blockedMedicine = !!product?.prescription_retention;

  const optionsGroup = product?.options_group ?? null;
  const pbmPromotions = product?.alerts.filter((alert: any) => alert.type.includes('pbm'));

  const optionModal = useModal();

  const selectCartAlertWasAskedAfterBuy = useSelector<ApplicationState, boolean>(
    (state) => state.customer.asks.cart_alert_after_buy,
  );

  const { cartItem, action, getInitialQuantity, initialQuantity } = useCartItemState({
    product,
    order,
    currentMeasure,
  });

  const { handleSubmit } = useCartHandlers({
    order,
    product,
    action,
    getInitialQuantity,
    currentMeasure,
    optionsGroup,
    blockedMedicine,
    configs,
    selectCartAlertWasAskedAfterBuy,
    setShowIdenfificationModal,
    setShowCartAlertModal,
    optionModal,
  });

  return (
    <>
      {order && product && currentMeasure && (
        <Formik
          enableReinitialize
          className="add-to-cart"
          initialValues={getInitialFormValues(
            product,
            initialQuantity,
            currentMeasure,
            action,
            cartItem,
            optionsGroup,
          )}
          onSubmit={handleSubmit}
        >
          {() => (
            <FormContentRenderer
              action={action}
              product={product}
              pbmPromotions={pbmPromotions}
              showType={showType}
              pbmBuyButton={pbmBuyButton}
              configs={configs}
              styles={styles}
              btnStyles={btnStyles}
              fullWidth={fullWidth}
              formClasses={formClasses}
              optionModal={optionModal}
              optionsGroup={optionsGroup}
              currentMeasure={currentMeasure}
              quantityInputDirection={quantityInputDirection}
              isAvailable={isAvailable}
              hideQuantityInput={hideQuantityInput}
            />
          )}
        </Formik>
      )}
    </>
  );
}

export default SaleForm;
